import { render } from "./uk5.vue?vue&type=template&id=459c53e4"
import script from "./uk5.vue?vue&type=script&lang=js"
export * from "./uk5.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__